import { Modal } from '@electronicpartnerio/uic';

const galleryFactory = () => {
    let modal: Modal | null = null;

    const init = () => {
        const anchors = document.getElementsByClassName('gallery-item') as HTMLCollectionOf<HTMLAnchorElement>;
        Array.from(anchors).forEach((anchor: HTMLAnchorElement) => anchor.addEventListener('click', handleAnchorClick));
    };

    const handleAnchorClick = (e: MouseEvent) => {
        e.preventDefault();
        const { id, index } = (e.currentTarget as HTMLAnchorElement).dataset;
        const gallery = document.getElementById(id!) as HTMLDivElement;
        modal = modalFactory(gallery, index);

        document.body.appendChild(modal);
    };

    const handleCloseModal = (e: MouseEvent) => {
        e.preventDefault();
        modal && document.body.removeChild(modal);
    };

    const modalFactory = (gallery: HTMLDivElement, index: string): Modal => {
        const modal = document.createElement('uic-modal') as Modal;
        const carousel = document.createElement('uic-carousel');
        const pictures: HTMLCollectionOf<HTMLPictureElement> = gallery.getElementsByTagName('picture');
        carousel.setAttribute('header', '');
        carousel.setAttribute('canClose', '');
        carousel.setAttribute('paginationEllipsis', '');
        carousel.setAttribute('navi', '');
        carousel.setAttribute('loop', '');
        carousel.setAttribute('pagination', 'dots');
        carousel.setAttribute('activeIndex', index);
        carousel.addEventListener('onCloseClick', handleCloseModal as EventListener);

        Array.from(pictures).forEach((picture: HTMLPictureElement) => {
            const carouselItem = document.createElement('uic-carousel-item');

            const clonedPicture = picture.cloneNode(true) as HTMLPictureElement;

            clonedPicture.classList.add('gallery-modal-picture');

            carouselItem.appendChild(clonedPicture);
            carousel.appendChild(carouselItem);
        });

        modal.setAttribute('preventCloseCross', '');
        modal.setAttribute('isOpen', '');
        modal.appendChild(carousel);

        return modal;
    };

    init();
};

export default galleryFactory;
